import { Icon } from '@aibees/shared/components';
import { classnames, formatPriceNumber } from '@aibees/shared/utils';
import {
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupAllOptionProps as Props } from './types';

const POPPER_PROPS_DISABLE_PORTAL = { disablePortal: true };

export const AdvancedTableSelectPopupAllOption = memo(
  ({ className, onClick, sizeLimit }: Props) => {
    const renderSelectAllOption = useMemo(() => {
      if (sizeLimit.systemLimitReached)
        return `Select Max. Amount of Records (${formatPriceNumber(
          sizeLimit.systemLimit
        )})`;
      return `Select All Results (${formatPriceNumber(
        sizeLimit.normalRowsLimit
      )})`;
    }, [
      sizeLimit.normalRowsLimit,
      sizeLimit.systemLimit,
      sizeLimit.systemLimitReached,
    ]);

    const isSystemLimitReached = useMemo(() => {
      return sizeLimit.systemLimitReached;
    }, [sizeLimit.systemLimitReached]);

    const systemLimit = useMemo(() => {
      return sizeLimit.normalRowsLimit;
    }, [sizeLimit.normalRowsLimit]);

    return (
      <Styled.Wrapper
        className={classnames('AdvancedTableSelectPopupAllOption', className)}
        sx={SX.root}
        onClick={onClick as ListItemButtonProps['onClick']}
      >
        <ListItemIcon>
          <Icon name="fact-check-outline" color="grey.800" size={18} />
        </ListItemIcon>

        <ListItemText sx={SX.text}>{renderSelectAllOption}</ListItemText>

        <Tooltip
          PopperProps={POPPER_PROPS_DISABLE_PORTAL}
          title={`For Performance reasons, the number of records is caped to ${formatPriceNumber(
            systemLimit
          )}`}
          arrow
          placement="top"
        >
          <Icon size={16} name="info" color="grey.400" />
        </Tooltip>
      </Styled.Wrapper>
    );
  }
);

AdvancedTableSelectPopupAllOption.displayName =
  'AdvancedTableSelectPopupAllOption';
